// extracted by mini-css-extract-plugin
export default {"container":"BM-z","topReviewHeading":"CM-z","criticalReview":"DM-z","favorableReview":"EM-z","vsSeparator":"FM-z"};